<main class="h-screen flex flex-col">
  @if (loadingService.loading()) {
    <div
      class="max-w-full max-h-full size-full sm:w-auto overflow-auto flex items-center justify-center"
    >
      <app-page-loader></app-page-loader>
    </div>
  } @else {
    <router-outlet></router-outlet>
  }
</main>
